import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import WorkflowIntroductionComponent from '../dashboard/WorkflowIntroductionComponent';

function MarketplaceView() {
  return (
    <MainLayout>
      <div className='marketplace-page'>
        <WorkflowIntroductionComponent />
      </div>
    </MainLayout>
  );
}

export default MarketplaceView;
